import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import Orders from "./orders";
import Reports from "./reports";
import Loyalty from "./loyalty";

const APP_PREFIX_PATH = "/cms";

export const AppViews = () => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Routes>
        <Route path={`/reports/*`} element={<Reports />} />
        <Route path={`/orders`} element={<Orders />} />
        <Route path={`/loyalty/*`} element={<Loyalty />} />
        <Route path={``} element={<Navigate to={`${APP_PREFIX_PATH}/orders`} replace />} />
      </Routes>
    </Suspense>
  );
};

export default React.memo(AppViews);
